module.exports = __webpack_public_path__ + "static/media/P2-sm-close.aed32194.svg";